module.exports = __webpack_public_path__ + "static/social-ddf-06d19525b194839080ad87ec72f19825.mp4";